module.exports = __webpack_public_path__ + "img/9.2c5257dd.jpg";